import type { ImmutableArray } from "shelving";
import { Icon, MediaIcon } from "shared/react";
import { REWARD_TYPES, type RewardType } from "shared/schema";
import { useItem } from "../util/db.js";

export function RawRewardIcon({ type, image = null, name = REWARD_TYPES[type], mods }: { image?: string | null | undefined; name?: string | undefined; type: RewardType; mods?: string | undefined }): React.ReactElement {
	return image ? <MediaIcon path={image} title={name} mods={mods} /> : <Icon icon={type} title={name} mods={mods} />;
}

/** Load a single reward images by its ID. */
export function RewardIcon({ id, type, mods }: { id: string; type: RewardType; mods?: string | undefined }): React.ReactElement | null {
	const item = useItem("reward", id);
	return <RawRewardIcon {...item.value} type={type} mods={mods} />;
}

/** Load a set of reward images by their IDs. */
export function RewardIcons({ ids, type, mods = "" }: { ids: ImmutableArray<string>; type: RewardType; mods?: string | undefined }): React.ReactElement {
	return (
		<figure className={`icons ${mods}`}>
			{ids.map(id => (
				<RewardIcon key={id} id={id} type={type} />
			))}
		</figure>
	);
}
